import { render, staticRenderFns } from "./ActivitatCrud.vue?vue&type=template&id=812b1bd4&scoped=true&"
import script from "./ActivitatCrud.vue?vue&type=script&lang=js&"
export * from "./ActivitatCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812b1bd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
